<!-- TOP BAR -->
<header class="topbar">
  <a class="brand" (click)="navigateToRoute('/docs/quick-reference')">
    <span class="brand-mark">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="12" r="6" fill="white" fill-opacity="0.95" />
        <circle cx="15" cy="12" r="6" fill="white" fill-opacity="0.55" />
      </svg>
    </span>
    <span class="brand-name">PIQET</span>
    <span class="brand-tag">Docs</span>
  </a>
  <span class="version-select">
    <span class="dot"></span>
    v1.0
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6" /></svg>
  </span>
  <div class="topbar-right">
    <a class="nav-link" (click)="navigateToRoute('/docs/lca-api')">LCA API</a>
    <a class="nav-link" (click)="navigateToRoute('/docs/lca-api/auth')">Auth API</a>
    <a class="nav-link" (click)="navigateToRoute('/docs/quick-reference')">Quick Reference</a>
  </div>
</header>

<div class="layout" *ngIf="data">
  <!-- SIDEBAR -->
  <aside class="sidebar">
    <div class="search">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></svg>
      <input #searchInput type="text" placeholder="Search reference..." [(ngModel)]="searchQuery" />
      <kbd>/</kbd>
    </div>

    <nav>
      <ng-container *ngFor="let section of filteredNavSections">
        <div class="nav-section">
          <div class="nav-section-title">{{ section.title }}</div>

          <ng-container *ngIf="section.children">
            <div
              class="nav-child"
              *ngFor="let child of section.children"
              [class.active]="child.isActive"
              (click)="setActiveNavChild(child)"
            >{{ child.label }}</div>
          </ng-container>

          <ng-container *ngIf="section.items">
            <ng-container *ngFor="let item of section.items">
              <div class="nav-item" [class.open]="item.isExpanded" (click)="toggleNavItem(item)">
                <svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6" /></svg>
                {{ item.label }}
              </div>
              <div class="nav-children" [style.display]="item.isExpanded ? 'block' : 'none'">
                <div
                  class="nav-child"
                  *ngFor="let child of item.children"
                  [class.active]="child.isActive"
                  (click)="setActiveNavChild(child); $event.stopPropagation()"
                >{{ child.label }}</div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </nav>
  </aside>

  <!-- MAIN CONTENT -->
  <main class="content">
    <nav class="breadcrumb fade-in fade-in-1">
      API Reference
      <span class="sep">/</span>
      <span class="current">Quick Reference</span>
    </nav>

    <div class="title-row fade-in fade-in-1">
      <h1 class="page-title">Quick <em>reference.</em></h1>
    </div>

    <p class="lede fade-in fade-in-2">{{ data.subtitle }}</p>

    <!-- =============== INDICATORS =============== -->
    <section class="ref-card" id="indicators" [class.highlighted]="isHighlighted('indicators')">
      <h2 class="ref-card-title">
        Indicators
        <span class="info-tip">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></svg>
          <span class="info-tip-text">
            Use a <strong>single indicator</strong> name or an <strong>indicator set</strong> name as the IndicatorLabel value.
          </span>
        </span>
      </h2>

      <!-- Single Indicators -->
      <div class="accordion" [class.open]="isIndicatorSectionExpanded('singleIndicators')">
        <div class="accordion-head" (click)="toggleIndicatorSection('singleIndicators')">
          <span class="expand-ico">{{ isIndicatorSectionExpanded('singleIndicators') ? '−' : '+' }}</span>
          <span class="accordion-label">{{ data.sections.singleIndicators.title }}</span>
        </div>
        <div class="accordion-body" *ngIf="isIndicatorSectionExpanded('singleIndicators')">
          <div class="chip-grid">
            <div class="chip" *ngFor="let ind of data.sections.singleIndicators.items">
              <span class="chip-text">{{ ind.name }}</span>
              <button class="chip-copy" [class.copied]="isCopied(ind.name)" (click)="copyToClipboard(ind.name, $event)">
                <svg *ngIf="!isCopied(ind.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
                <svg *ngIf="isCopied(ind.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5" /></svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Indicator Sets -->
      <div class="accordion" [class.open]="isIndicatorSectionExpanded('indicatorSets')">
        <div class="accordion-head" (click)="toggleIndicatorSection('indicatorSets')">
          <span class="expand-ico">{{ isIndicatorSectionExpanded('indicatorSets') ? '−' : '+' }}</span>
          <span class="accordion-label">{{ data.sections.indicatorSets.title }}</span>
        </div>
        <div class="accordion-body" *ngIf="isIndicatorSectionExpanded('indicatorSets')">
          <div class="ftable">
            <div class="ftable-head two-col">
              <span>Indicator Set</span><span>Description</span>
            </div>
            <div class="ftable-row two-col" *ngFor="let s of data.sections.indicatorSets.items">
              <span class="param-name">
                {{ s.name }}
                <button class="chip-copy inline" [class.copied]="isCopied(s.name)" (click)="copyToClipboard(s.name, $event)">
                  <svg *ngIf="!isCopied(s.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
                  <svg *ngIf="isCopied(s.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5" /></svg>
                </button>
              </span>
              <span class="col-desc">{{ s.description }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- =============== TRANSPORT MODES =============== -->
    <section
      class="ref-card"
      [id]="data.sections.transportModes.id"
      [class.highlighted]="isHighlighted(data.sections.transportModes.id)"
    >
      <h2 class="ref-card-title">{{ data.sections.transportModes.title }}</h2>
      <div class="chip-grid">
        <div class="chip wide" *ngFor="let t of data.sections.transportModes.items">
          <span class="chip-text">{{ t.mode }}</span>
          <span class="chip-sub">{{ t.description }}</span>
          <button class="chip-copy" [class.copied]="isCopied(t.mode)" (click)="copyToClipboard(t.mode, $event)">
            <svg *ngIf="!isCopied(t.mode)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
            <svg *ngIf="isCopied(t.mode)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5" /></svg>
          </button>
        </div>
      </div>
    </section>

    <!-- =============== PACKING LEVELS =============== -->
    <section
      class="ref-card"
      [id]="data.sections.packingLevels.id"
      [class.highlighted]="isHighlighted(data.sections.packingLevels.id)"
    >
      <h2 class="ref-card-title">{{ data.sections.packingLevels.title }}</h2>
      <div class="ftable">
        <div class="ftable-head three-col">
          <span>Level</span><span>Name</span><span>Description</span>
        </div>
        <div class="ftable-row three-col" *ngFor="let lv of data.sections.packingLevels.items">
          <span><span class="level-num">{{ lv.level }}</span></span>
          <span class="param-name">
            {{ lv.name }}
            <button class="chip-copy inline" [class.copied]="isCopied(lv.name)" (click)="copyToClipboard(lv.name, $event)">
              <svg *ngIf="!isCopied(lv.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
              <svg *ngIf="isCopied(lv.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5" /></svg>
            </button>
          </span>
          <span class="col-desc">{{ lv.description }}</span>
        </div>
      </div>
    </section>

    <!-- =============== STORAGE TYPES =============== -->
    <section
      class="ref-card"
      [id]="data.sections.storageTypes.id"
      [class.highlighted]="isHighlighted(data.sections.storageTypes.id)"
    >
      <h2 class="ref-card-title">
        {{ data.sections.storageTypes.title }}
        <span class="info-tip">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></svg>
          <span class="info-tip-text">Set <strong>Storage</strong> from these predefined options based on the distribution stage.</span>
        </span>
      </h2>
      <div class="category-grid">
        <div class="category-card" *ngFor="let cat of data.sections.storageTypes.categories">
          <h3 class="category-card-title">{{ cat.name }}</h3>
          <div class="chip-list">
            <div class="chip compact" *ngFor="let item of cat.items">
              <span class="chip-text">{{ item.name }}</span>
              <button class="chip-copy" [class.copied]="isCopied(item.name)" (click)="copyToClipboard(item.name, $event)">
                <svg *ngIf="!isCopied(item.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
                <svg *ngIf="isCopied(item.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5" /></svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- =============== FILLING PROCESS =============== -->
    <section
      class="ref-card"
      [id]="data.sections.fillingProcess.id"
      [class.highlighted]="isHighlighted(data.sections.fillingProcess.id)"
    >
      <h2 class="ref-card-title">
        {{ data.sections.fillingProcess.title }}
        <span class="info-tip">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></svg>
          <span class="info-tip-text">Set <strong>Filling Process</strong> from these predefined options.</span>
        </span>
      </h2>
      <div class="chip-grid">
        <div class="chip" *ngFor="let item of data.sections.fillingProcess.items">
          <span class="chip-text">{{ item.name }}</span>
          <button class="chip-copy" [class.copied]="isCopied(item.name)" (click)="copyToClipboard(item.name, $event)">
            <svg *ngIf="!isCopied(item.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
            <svg *ngIf="isCopied(item.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5" /></svg>
          </button>
        </div>
      </div>
    </section>

    <!-- =============== MATERIALS =============== -->
    <section
      class="ref-card"
      [id]="data.sections.materials.id"
      [class.highlighted]="isHighlighted(data.sections.materials.id)"
    >
      <h2 class="ref-card-title">
        {{ data.sections.materials.title }}
        <span class="info-tip">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></svg>
          <span class="info-tip-text">Set <strong>Materials</strong> from these predefined options.</span>
        </span>
      </h2>
      <div class="category-grid dense">
        <div class="category-card" *ngFor="let cat of data.sections.materials.categories">
          <h3 class="category-card-title">{{ cat.name }}</h3>
          <div class="chip-list">
            <div class="chip compact" *ngFor="let item of cat.items">
              <span class="chip-text">{{ item.name }}</span>
              <button class="chip-copy" [class.copied]="isCopied(item.name)" (click)="copyToClipboard(item.name, $event)">
                <svg *ngIf="!isCopied(item.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
                <svg *ngIf="isCopied(item.name)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5" /></svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>

  <!-- FOOTER -->
  <footer>
    <div>PIQET &middot; <span class="footer-version">v1.0</span></div>
    <div class="databases">
      <span>REST API</span>
      <span class="sep">&middot;</span>
      <span>JSON</span>
      <span class="sep">&middot;</span>
      <span>OpenAPI 3.1</span>
    </div>
    <div class="status-indicator">
      <span class="dot"></span>
      All systems operational
    </div>
  </footer>
</div>

<!-- Loading State -->
<div class="loading-container" *ngIf="!data">
  <div class="loading-spinner"></div>
  <p>Loading Quick Reference...</p>
</div>
